import { Card } from '@mantine/core';
import { IconFileInfo } from '@tabler/icons-react';
import { Section, SectionProps } from './Section';
import { useGetModalSectionBorderColor } from 'hooks/useGetModalSectionBorderColor';

export const ClaimInfoSection = ({
  index,
  title,
  keys,
  cols,
  editComponentsMap,
  type = 'edit',
  focusRef,
}: SectionProps) => {
  const borderColor = useGetModalSectionBorderColor({
    keys,
  });
  const icon = <IconFileInfo size={20} />;

  return (
    <Card
      padding={'md'}
      shadow="xs"
      radius="md"
      withBorder
      style={{ borderColor: borderColor }}
      ref={focusRef}
      tabIndex={-1}
    >
      <Section
        index={index}
        title={title}
        icon={icon}
        keys={keys}
        className="claim-info-section"
        cols={cols}
        editComponentsMap={editComponentsMap}
        type={type}
      />
    </Card>
  );
};
